import React from 'react';
import moment from 'moment';
import propTypes from 'prop-types';
import { withRouter } from 'react-router';
import s from './style.less';

class PayCard extends React.Component {
  static propTypes = {
    getDebts: propTypes.func,
    setPayed: propTypes.func,
    amount: propTypes.string,
    match: propTypes.object,
  };

  state = {
    text: '',
    error: '',
    cardNum: '',
  };

  setCardNum = ({ target: { value } }) => {
    this.setState({
      cardNum: value.replace(/\D/g, '').replace(/(\d{4})/g, '$1 '),
    });
  };
  preventWheel = e => e.preventDefault();

  submit = async e => {
    if (this.state.loading) return;
    this.setState({
      error: '',
      text: '',
      loading: true,
    });
    e.preventDefault();
    const body = new window.FormData(e.target);
    const { id } = this.props.match.params;
    const req = await fetch(`/user/pay-underfunded/${id}`, {
      method: 'post',
      body,
      useNative: true,
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }).then(r => r.json());
    if (req.error) {
      return this.setState({
        text: '',
        error: req.error,
        loading: false,
      });
    }
    this.props.setPayed();
    return this.setState({
      text: req.data,
      showClose: true,
      loading: false,
      disabled: true,
    });
  };

  backspase = e => {
    if (e.keyCode === 8 && this.state.cardNum.substr(-1) === ' ') {
      this.setState({
        cardNum: this.state.cardNum.substr(0, this.state.cardNum.length - 1),
      });
    }
  };

  close = () => {
    this.setState({
      showClose: false,
    });
    this.props.getDebts();
  };

  render() {
    return (
      <div className={s.root}>
        <form onSubmit={this.submit}>
          <div>
            <div>Card type</div>
            <label>
              <input
                type="radio"
                value="VISA"
                name="CardType"
                required="true"
              />
              <div className={s.visa} />
            </label>
            <label>
              <input
                type="radio"
                value="DELTA"
                name="CardType"
                required="true"
              />
              <div className={s.visa_debit} />
            </label>
            <label>
              <input type="radio" value="MC" name="CardType" required="true" />
              <div className={s.mastercard} />
            </label>
            <div className={s.secured} />
          </div>
          <br />
          <br />
          <div>
            <div>CARD NUMBER</div>
            <input
              className={s.number}
              name="CardNumber"
              required="true"
              value={this.state.cardNum}
              onChange={this.setCardNum}
              minLength="4"
              maxLength="19"
              onKeyDown={this.backspase}
            />
          </div>
          <br />
          <div>
            <div>CARDHOLDER NAME</div>
            <input className={s.number} name="CardHolder" required="true" />
          </div>
          <br />
          <div className={s.expire}>
            <div>EXPIRY DATE</div>
            <input
              name="expirationMonth"
              placeholder="MM"
              min="1"
              max="12"
              type="number"
              step="1"
              required="true"
              onWheel={this.preventWheel}
            />
            &nbsp; &nbsp;
            <input
              name="expirationYear"
              placeholder="YY"
              min={moment().format('YY')}
              type="number"
              step="1"
              required="true"
              onWheel={this.preventWheel}
            />
          </div>
          <div className={s.cvv}>
            <div>CVV</div>
            <input
              className={s.cvv}
              name="CV2"
              placeholder="CVV"
              type="number"
              step="1"
              required="true"
              onWheel={this.preventWheel}
            />
          </div>
          <br />
          <br />
          <div className={s.hidden}>
            <input
              name="Amount"
              defaultValue={this.props.amount}
              type="number"
              min="0"
              step="0.01"
              required="true"
              onWheel={this.preventWheel}
              readOnly
              className={s.number}
            />
          </div>
          <input
            type="submit"
            className={s.submit}
            value="Submit"
            disabled={this.state.loading || this.state.disabled}
          />
          {this.state.loading && (
            <div className={s.spinner}>
              <span className="fa fa-spinner fa-spin" />
            </div>
          )}
        </form>
        {this.state.text && <div className={s.success}>{this.state.text}</div>}
        {this.state.error && <div className={s.error}>{this.state.error}</div>}
        {this.state.showClose && (
          <div className={s.submit} onClick={this.close}>
            Close
          </div>
        )}
        <br />
        <br />
      </div>
    );
  }
}

export default withRouter(PayCard);
